import React, { useState, ReactNode } from "react";
import { Modal } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { TextService } from "../../Services/TextService";

type HelpModalProps = {
    /** Content shown inside the modal */
    children: ReactNode;
    /** Optional title for the modal */
    title?: string;
    /** Optional custom icon style */
    iconStyle?: React.CSSProperties;
};

export const HelpModal: React.FC<HelpModalProps> = ({
    children,
    title,
    iconStyle,
}) => {
    const modalTitle = title ?? TextService.GetText("Common_Help");
    const [isHelpModalOpen, setIsHelpModalOpen] = useState<boolean>(false);

    const handleOpen = () => setIsHelpModalOpen(true);
    const handleClose = () => setIsHelpModalOpen(false);

    return (
        <>
            <QuestionCircleOutlined
                style={{ color: "#1677ff", cursor: "pointer", ...iconStyle }}
                onClick={handleOpen}
            />

            <Modal
                title={modalTitle}
                open={isHelpModalOpen}
                onCancel={handleClose}
                onOk={handleClose}
                footer={null} // or keep default footer if you prefer
            >
                {children}
            </Modal>
        </>
    );
};